import { useAtom } from 'jotai'

import { SwitchLineInput } from '@sequencehq/core-components'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'

import { subItemsEnabledAtom } from '../state.atoms'

export const AddSubItemsToggle = () => {
  const [isEnabled, setIsEnabled] = useAtom(subItemsEnabledAtom)

  return (
    <SwitchLineInput
      data-testid="lineItemEditor.subItems.toggle"
      value={isEnabled}
      onChange={isActive => setIsEnabled(isActive)}
      text="Add sub items"
      styles={{ label: { color: GreyGrey80, ...Primary13Regular } }}
    />
  )
}
